import { VOCABULARY } from './constants.js';

export function getViewableSubjects(filters, subjects) {
  subjects = filterByType(filters.types, subjects);
  subjects = filterBySrs(filters.srs, subjects);
  subjects = filterByText(filters.text, subjects);
  subjects = filterByPartOfSpeech(filters.partsOfSpeech, subjects);
  subjects = filterByPercentageCorrect(
    filters.percentageCorrectThreshold,
    subjects
  );
  return subjects;
}

function filterByType(filterSubjects, subjects) {
  if (filterSubjects.length) {
    return subjects.filter(subject => filterSubjects.includes(subject.type));
  }
  return subjects;
}

function filterByText(searchText, subjects) {
  if (searchText) {
    return subjects.filter(subject => {
      const lowerCaseSearch = searchText.toLowerCase();
      return (
        subject.meaning.toLowerCase().includes(lowerCaseSearch) ||
        (subject.characters && subject.characters.includes(searchText)) ||
        (subject.reading && subject.reading.includes(searchText))
      );
    });
  }
  return subjects;
}

function filterBySrs(filterSubjects, subjects) {
  if (filterSubjects.length) {
    const srsStageRegex = /Apprentice|Guru|Master|Enlightened|Burned/;
    return subjects.filter(subject =>
      filterSubjects.includes(subject.srs_stage_name.match(srsStageRegex)[0])
    );
  }
  return subjects;
}

function filterByPartOfSpeech(filterSubjects, subjects) {
  if (filterSubjects.length) {
    return subjects.filter(subject => {
      if (subject.type !== VOCABULARY) return false;
      return subject.parts_of_speech.some(partOfSpeech =>
        filterSubjects.includes(partOfSpeech)
      );
    });
  }
  return subjects;
}

function filterByPercentageCorrect(threshold, subjects) {
  return subjects.filter(subject => subject.percentage_correct <= threshold);
}
